import React from "react";
import PropTypes from "prop-types";

const CameraCluster = ({ fillColor, width, height }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" fill={fillColor} width={width} height={height}>
			<g>
				<g id="Layer_1">
					<path
						fillRule="evenodd"
						d="M719.1,336.3c16.8-39.3,55.9-66.9,101.4-66.9s110.2,49.4,110.2,110.2-28.3,85.6-68.5,102l25.7,102.9c24,2.3,42.8,22.5,42.8,47s-21.2,47.2-47.2,47.2-47.2-21.2-47.2-47.2,8.4-30.9,21.2-39.4l-25.7-102.9c-3.7.4-7.4.6-11.2.6-7.5,0-14.8-.8-21.9-2.2l-84.1,235.4c34.9,18.5,58.7,55.2,58.7,97.4s-.3,10-1,14.8l72.7,20.8c8.6-12,22.6-19.9,38.5-19.9,26.1,0,47.2,21.2,47.2,47.2s-21.2,47.2-47.2,47.2-45.6-19.6-47.1-44.3l-72.7-20.8c-17.3,38.4-55.8,65.1-100.6,65.1s-110.2-49.4-110.2-110.2,8.2-47.6,22-66l-129.2-129.2c-14.4,10.8-31.6,18.2-50.2,20.8v129.8c18.3,6.5,31.5,24,31.5,44.5s-21.2,47.2-47.2,47.2-47.2-21.2-47.2-47.2,13.1-38.1,31.5-44.5v-129.8c-53.4-7.7-94.5-53.6-94.5-109.1s41.1-101.4,94.5-109.1v-66.8c-18.3-6.5-31.5-24-31.5-44.5s21.2-47.2,47.2-47.2,47.2,21.2,47.2,47.2-13.1,38.1-31.5,44.5v66.8c35.5,5.1,65.5,27.1,81.7,57.6l235.4-84.1c-1.4-7.1-2.2-14.4-2.2-21.9s.2-8.7.8-12.9l-87.7-23.4c-8.5,12.4-22.8,20.5-39,20.5-26.1,0-47.2-21.2-47.2-47.2s21.2-47.2,47.2-47.2,45.2,19.2,47.1,43.5l87.7,23.4ZM723,431.1c10.4,19.5,26.4,35.6,45.9,45.9l-84.1,235.4c-7.1-1.4-14.4-2.2-21.9-2.2-24.7,0-47.6,8.2-66,22l-129.2-129.2c13.8-18.4,22-41.2,22-66s-.8-14.8-2.2-21.9l235.4-84.1Z"
					/>
				</g>
			</g>
		</svg>
	);
};

CameraCluster.propTypes = {
	fillColor: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string
};

// Default props
CameraCluster.defaultProps = {
	fillColor: "#FFFFFF",
	width: "35px",
	height: "35px"
};

export default CameraCluster;
